import api from '../api'
import auth from '../token'

export default {

  async getHomeData() {

    const role = localStorage.getItem('role');
    const username = localStorage.getItem('user');

    if (role === 'ADMIN') {
      const getHomeData = await api.request('GET', '/backedFile/information?station=&profile=ADMIN&dateTo=&dateFrom=');
      return getHomeData;
    } else {
      const getHomeData = await api.request('GET', '/backedFile/information?station=' + auth.getStationNumber() + '&profile=STATION&dateTo=&dateFrom=');
      return getHomeData;
    }
  },

  async list(page, size = 5) {
    const role = localStorage.getItem('role');
    const station = localStorage.getItem('station');
    
    if (role === 'ADMIN') {
      const list = await api.request('GET', '/backedFile/list?page=&size=' + size + '&order=desc');
      return list;
    } else {
      const list = await api.request('GET', '/backedFile/list/' + station + '?page=' + page + '&size=' + size + '&order=desc');
      return list;
    }
  }
}